import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useIsLoyaltyEnabled = () => Boolean(useFlag(LaunchDarklyFlag.ENABLE_LOYALTY));
